export const donations = {
  tableHeaders: [
    {
      titleKey: 'amount',
      key: 'amount',
      getValue: row => {
        try {
          return row.amount.toFixed(2) + (row.currency === 'USD' || row.currency === 'usd' ? ' $' : ' €')
        } catch (error) {
          return '-'
        }
      }
    },
    {
      titleKey: 'date',
      key: 'date',
      type: 'date',
      options: {
        format: 'MMM YYYY'
      }
    },
    {
      titleKey: 'payments_num',
      key: 'payments_num',
      getValue: row => (row.payments ? row.payments.length : '-')
    },
    {
      titleKey: 'payments_avg',
      key: 'payments_avg',
      getValue: row =>
        (row.amount / row.payments.length).toFixed(2) + (row.currency === 'USD' || row.currency === 'usd' ? ' $' : ' €')
    }
  ],
  rowActions: [
    {
      title: 'Details',
      name: 'details',
      icon: 'icon-look'
    }
  ],
  radioFilter: [
    {
      titleKey: 'all',
      value: null,
      key: 'method'
    },
    {
      titleKey: 'affiliate',
      value: 'affiliate',
      key: 'method'
    },
    {
      titleKey: 'pos',
      value: 'pos',
      key: 'method'
    }
  ]
}

export const donationDetails = {
  tableHeaders: [
    {
      titleKey: 'merchant',
      key: 'merchant',
      getValue: row => (row.merchant ? row.merchant.name : '-')
    },
    {
      titleKey: 'donation_merchant',
      key: 'donation',
      getValue: row => {
        try {
          return row.chosenByUser
            ? (row.donation - row.donationUser).toFixed(2) +
                (row.currency === 'USD' || row.currency === 'usd' ? ' $' : ' €')
            : '-'
        } catch (error) {
          return '-'
        }
      }
    },
    {
      titleKey: 'donation_user',
      key: 'donationUser',
      getValue: row => {
        try {
          return row.chosenByMerchant
            ? row.donationUser.toFixed(2) + (row.currency === 'USD' || row.currency === 'usd' ? ' $' : ' €')
            : '-'
        } catch (error) {
          return '-'
        }
      }
    },
    {
      titleKey: 'date',
      key: 'date',
      type: 'date',
      options: {
        format: "DD, MMM 'YY"
      }
    }
  ],
  radioFilter: []
}



// WEBPACK FOOTER //
// ./src/components/npos/tables/settings.js